/** @jsxImportSource @emotion/react */
import { FormContent, MainContent, Template } from 'components';
import { useInitPage } from 'hooks';
import React from 'react';
import { FORM_PAGE_TYPE, GlobalErrorMessages, Submissions } from 'shared';
import { ReCaptchaGlobalStyles } from '../shared';

export const Complete: React.FC = () => {
  const { currentFormPage, mainContentRef, globalErrors } = useInitPage();
  if (!currentFormPage) {
    return null;
  }
  const {
    design,
    header,
    footer,
    title,
    message,
    pageId,
    submissions,
    progressBar,
  } = currentFormPage;
  const displayError = !!globalErrors?.length;
  return (
    <>
      <ReCaptchaGlobalStyles reCaptchaSetting={undefined} />
      <Template header={header} footer={footer} design={design}>
        <MainContent
          title={title}
          message={displayError ? '' : message}
          pageType={FORM_PAGE_TYPE.COMPLETE}
          pageId={pageId}
          design={design}
          progressBar={progressBar}
          ref={mainContentRef}
        >
          <FormContent>
            <GlobalErrorMessages
              displayError
              errorMessages={globalErrors || []}
            />
            {!displayError && submissions && (
              <Submissions
                css={{ marginTop: '24px' }}
                submissions={submissions}
                disabled={{}}
                design={design}
              />
            )}
          </FormContent>
        </MainContent>
      </Template>
    </>
  );
};
